import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useT } from "../context/ContentContext";
import { useUI } from "../lib/i18n";

export default function Offers() {
  const t = useT();
  const ui = useUI();
  const offers = t("offers") || [];
  const scrollToContact = () => document.getElementById("contatti")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="consulenze" className="py-28 md:py-40 border-t border-white/5" data-testid="offers-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading index="03" label={ui.offers_label} title={t("offers_title") || "Le consulenze"} testid="offers-title" />
        <div className="mt-14">
          {offers.map((o, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <button
                onClick={scrollToContact}
                data-testid={`offer-row-${i}`}
                className={`group w-full text-left flex flex-col md:flex-row md:items-center gap-4 md:gap-12 py-10 md:py-14 border-t border-white/10 ${
                  i === offers.length - 1 ? "border-b" : ""
                } hover:translate-x-2 transition-transform duration-500`}
              >
                <span className="font-display font-black text-6xl md:text-8xl leading-none text-outline shrink-0 w-32">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1">
                  <h3 className="font-display font-bold tracking-tight text-2xl md:text-3xl group-hover:text-[#007AFF] transition-colors">
                    {o.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-zinc-400 leading-relaxed max-w-2xl">{o.description}</p>
                </div>
                <ArrowUpRight className="w-6 h-6 text-zinc-600 group-hover:text-[#007AFF] transition-colors shrink-0 hidden md:block" />
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
